export default __webpack_public_path__ + "static/media/popcorn@2x.cbd83c02.jpg";